import { Box, Center, Flex, useRadio, useRadioGroup } from '@chakra-ui/react';
import { useEffect } from 'react';

function RadioCard(props: any) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box
      as="label"
      w={props.buttonSize.w}
      h={props.buttonSize.h}
      position="relative">
      <input {...input} />
      <Center
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="md"
        _checked={{
          bg: '#f9fefb',
          color: 'black',
          borderWidth: '2px',
          borderColor: 'mint.500',
        }}
        h="56px"
        fontSize="14px"
        fontWeight={'medium'}>
        {props.children}
      </Center>
    </Box>
  );
}

interface IRadioButtonsProps {
  radioGroupName: string;
  defaultValue?: string;
  buttonList: string[];
  buttonSize: { w: string; h: string };
  onChange: (value: string) => void;
}
function RadioButtons({
  radioGroupName,
  defaultValue = '',
  buttonList,
  buttonSize,
  onChange,
}: IRadioButtonsProps) {
  const { getRootProps, getRadioProps, setValue } = useRadioGroup({
    name: radioGroupName,
    defaultValue: defaultValue,
    onChange: onChange,
  });

  const group = getRootProps();

  useEffect(() => {
    setValue('');
  }, [buttonList, setValue]);

  return (
    <Flex {...group} gap="10px" flexWrap={'wrap'}>
      {buttonList.map((value) => {
        const radio = getRadioProps({ value });
        return (
          <RadioCard key={value} {...radio} buttonSize={buttonSize}>
            {value}
          </RadioCard>
        );
      })}
    </Flex>
  );
}

export default RadioButtons;
